import apiHelper from '../../helper/ApiHelper';

const AdminApprovalRequestService = {
  async getApprovalRequests() {
    try {
      return await apiHelper('/approval-requests');
    } catch (error) {
      console.error('Error fetching heads:', error);
      throw error;
    }
  },

  async approveRequest(requestId) {
    try {
      return await apiHelper(`/approval-requests/approve/${requestId}`, 'POST');
    } catch (error) {
      console.error('Error updating head:', error);
      throw error;
    }
  },

  async rejectRequest(requestId) {
    try {
      return await apiHelper(`/approval-requests/reject/${requestId}`, 'POST');
    } catch (error) {
      console.error('Error updating head:', error);
      throw error;
    }
  },
};

export default AdminApprovalRequestService;